import { useState } from 'react';
import { useScore } from './context/ScoreContext';
import History from "./History";
import ImageHandler from './ImageHandler';

const Score = () => {
    const { day, score, gridCount, updateStateEndGame, gameEnded, hintVisibleToggle, setHintVisibleToggle } = useScore();
    const [showHistory, setShowHistory] = useState(false);
    // console.log("score", score);

    const handleEndGame = () => {
        const userResponse = window.confirm("Are you sure you want to end game, you wont be able to make any further selections and all blank options will be marked wrong?");
        if (userResponse) {
            console.log("User clicked Yes");
            updateStateEndGame();
        }
    }
    const handleShowHistory = () => {
        setShowHistory(true);
        document.body.style.overflow = 'hidden';
    }

    const handleHistoryClose = () => {
        setShowHistory(false);
        document.body.style.overflow = 'auto';
    }

    return (
        <div className="score">

            <h1>GRID: {gridCount}/9</h1>
            {/* <h1 id="score-image">SCORE: {Math.round(score.reduce((partialSum, a) => partialSum + a, 0))}</h1> */}

            <div>
                <button className='score-button' onClick={handleShowHistory}>💾 History </button>
                {!gameEnded ? <button className='score-button' onClick={handleEndGame}>📛 End Game </button> : <ImageHandler day={day} />}

                {showHistory && <div>
                    <History onClose={handleHistoryClose} />
                    <div className="overlay" onClick={handleHistoryClose} />
                </div>}
            </div>
            {!gameEnded && <button className={`score-button ${hintVisibleToggle ? "glow-animation" : ""}`} onClick={() => {
                setHintVisibleToggle(t => !t);
            }}>🛎️ Toggle Hint</button>}
        </div>
    );
}

export default Score;